import { render, staticRenderFns } from "./AdditionalHolidays.vue?vue&type=template&id=731b9784&scoped=true"
import script from "./AdditionalHolidays.vue?vue&type=script&lang=js"
export * from "./AdditionalHolidays.vue?vue&type=script&lang=js"
import style0 from "./AdditionalHolidays.vue?vue&type=style&index=0&id=731b9784&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731b9784",
  null
  
)

export default component.exports